import { motion } from 'motion/react'
import { Shield, Network, BarChart3, Settings } from 'lucide-react'
import { Badge } from '@/components/ui'

const steps = [
  {
    title: 'Security Assessment',
    description: 'We start by evaluating your current security posture, compliance requirements, and risk profile. Security is the foundation for everything that follows.',
    icon: Shield,
  },
  {
    title: 'Network Analysis',
    description: 'We assess your network infrastructure, bandwidth needs, and connectivity requirements to ensure it can support your communications goals securely.',
    icon: Network,
  },
  {
    title: 'Solutions Design',
    description: 'With security and network foundations understood, we design your UCaaS and CCaaS solutions from 100+ providers—data-backed, zero vendor bias.',
    icon: BarChart3,
  },
  {
    title: 'Implementation',
    description: 'As your strategic partner, we manage the rollout and provide ongoing Zoom Certified support to ensure long-term success and optimization.',
    icon: Settings,
  },
]

export function Process() {
  return (
    <section className="section-padding relative">
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <Badge className="mb-4">Our Methodology</Badge>
          <h2 className="text-display-sm md:text-display-md font-heading font-bold text-white mb-4">
            Security-First Technology Optimization
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Every engagement starts with security. We then build up through network, communications, and customer experience—ensuring each layer is optimized and protected.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative group"
            >
              {/* Connector line for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-[1px] bg-gradient-to-r from-accent-500/50 to-transparent -z-10" />
              )}
              
              <div className={`glass-card-hover p-8 rounded-2xl h-full flex flex-col items-center text-center ${index === 0 ? 'ring-2 ring-accent-500/30' : ''}`}>
                <div className={`w-16 h-16 rounded-2xl ${index === 0 ? 'bg-gradient-to-br from-accent-500 to-accent-600 shadow-glow' : 'bg-gradient-to-br from-accent-500/20 to-electric-500/20'} flex items-center justify-center mb-6 group-hover:shadow-glow transition-all`}>
                  <step.icon className={`w-8 h-8 ${index === 0 ? 'text-white' : 'text-accent-400'}`} />
                </div>
                <div className="text-2xs font-mono text-accent-500 mb-2">
                  {index === 0 ? 'FOUNDATION' : `STEP 0${index + 1}`}
                </div>
                <h3 className="text-xl font-heading font-semibold text-white mb-4">{step.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
